const config = {
  key: '',
  ListTitle: 'Cambiar plataforma',
  opcion: '',
  newButtonLabel: '',
  service: '',
  initialValues: {},
};

export default config;
